export default "__VITE_ASSET__a044cce6__"